import {
    Log,
} from 'one-log';

import {
    resolver,
} from './resolver';

import {
    settings,
} from 'one-loader';

export const loader = (
    options: any = {},
    init: (options: any) => Promise<{
        log: Log,
        next?: (options: any) => Promise<{
            store?: any;
        }>,
    }>,
) => {
    window.onload = async () => {
        // stage-1 initialization
        console.info(
            'one-web-loader',
            'begin stage-1 init', {
            options,
        });

        const {
            url = 'settings.json',
            queryParams = false,
        } = options;

        try {
            const resolved = resolver(
                url,
            );

            console.info(
                'one-web-loader',
                'stage-1, loading settings'
            );

            const resp = await settings(
                resolved,
                options,
            );

            const params: any = {};
            if (queryParams) {
                console.info(
                    'one-web-loader',
                    'stage-1, extracting query parameters'
                );
                const search = new URLSearchParams(
                    window.location.search
                );

                search.forEach((value: any, key: string) => {
                    params[key] = value;
                });

                console.debug(
                    'one-web-loader',
                    'stage-1, query parameters',
                    params,
                );
            }

            const {
                log,
                next,
            } = await init({
                params,
                resolver,
                settings: resp,
            });

            log.info(
                'one-web-loader',
                'stage-1 init completed'
            );

            if (!(next)) {
                log.info(
                    'one-web-loader',
                    'no stage-2, init completed'
                );
            } else {
                log.info(
                    'one-web-loader',
                    'begin stage-2 init'
                );
                try {
                    await next({});
                    log.info(
                        'one-web-loader',
                        'stage-2 init completed'
                    );
                } catch (exp) {
                    log.error(
                        'one-web-loader',
                        'stage-2 init failed',
                        exp,
                    );
                }
            }
        } catch (exp) {
            console.error(
                'one-web-loader',
                'stage-1 init failed',
                exp,
            );
        }
    }
};
